module.exports = __webpack_public_path__ + "static/media/demo.021baca2.gif";